import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('FlexContainer')(
  css({
    mb: 'default',
    width: '100%',
    minHeight: '143px',
    alignItems: 'center',
    justifyContent: 'center',
    display: ['block', 'block', 'flex'],
  }),
);

themeStyles.addBaseStyles('VehicleImage')(
  css({
    flexBasis: '50%',
    alignSelf: 'center',
    objectFit: 'contain',
    minHeight: ['160px', '160px', '143px'],
    maxWidth: ['280px', '280px', '246px'],
    width: ['100%', '100%', '50%'],
    marginLeft: ['auto', 'auto', 0],
    marginRight: ['auto', 'auto', 0],
  }),
);

themeStyles.addBaseStyles('BadgeWrapper')(
  css({
    flexBasis: '50%',
  }),
);

themeStyles.addBaseStyles('ModelBadge')(
  css({
    height: ['15px', '15px', '23px'],
    objectPosition: 'left',
    objectFit: 'contain',
    marginX: '0',
    mb: 'xs',
  }),
);

export default themeStyles;
